export default __webpack_public_path__ + "static/media/037-sculpting tools.6295c2fe.svg";